// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const TicketExpiredIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20",
  "aria-hidden": "true",
  "data-icon": "TicketExpired/solid"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M16.542 10.783c0 .667.541 1.217 1.208 1.217.317 0 .583.258.583.575 0 3.2-.966 4.167-4.166 4.167H9.792v-1.325a.618.618 0 0 0-.567-.617c-.017-.008-.042-.008-.058-.008a.63.63 0 0 0-.625.625v1.325H7.075c-1.567 0-2.375-1.175-3.108-2.95l-.142-.35a.584.584 0 0 1 .325-.759c.308-.116.55-.358.675-.675.133-.308.133-.65.008-.958-.266-.642-1-.95-1.65-.692a.531.531 0 0 1-.45 0 .605.605 0 0 1-.316-.325L2.292 9.7c-1.242-3.017-.7-4.308 2.316-5.558L6.65 3.3c.3-.125.642.017.758.317l1.817 3.958c-.342 0-.683.275-.683.617v3.616a.63.63 0 0 0 .625.625c.016 0 .041 0 .058-.008a.618.618 0 0 0 .567-.617V8.192a.618.618 0 0 0-.567-.617V4.108h4.942c3.2 0 4.166.967 4.166 4.167v.708a.585.585 0 0 1-.583.584 1.21 1.21 0 0 0-1.208 1.216Z"
}));
export default TicketExpiredIcon;